import React from 'react';
import { StyledContainer, StyledListContainer, StyledOrderedList, StyledOItem, StyledHeader } from './styles';

const StepItem = ({ step }) => (
  <StyledOItem>{ step.name }</StyledOItem>
); 

const Steps = ({ goal }) => (
  <StyledContainer className={ goal ? 'half-width' : 'hidden' }>
    <StyledHeader>Steps</StyledHeader>

    { goal &&
      <StyledListContainer>
        <StyledOrderedList>
          { goal.steps.map(step => <StepItem step={step} /> )}
        </StyledOrderedList>
      </StyledListContainer>
    }
  </StyledContainer>
);

export default Steps;
